import { Skeleton, Space } from 'antd'

type Props = {
  /** Kaç iskelet bloğu çizilecek. Varsayılan 3. */
  rows?: number
  /** Bloklar üstünde başlık placeholder'ı. Varsayılan true. */
  withTitle?: boolean
}

/**
 * Genel sayfa düzeyi yükleme placeholder'ı. Suspense veya üst düzey query ile
 * yüklenen rotalar için. Tutarlı görsel ritim için ad-hoc `<Spin/>` yerine tercih edin.
 */
const PageSkeleton = ({ rows = 3, withTitle = true }: Props) => (
  <Space orientation="vertical" size={20} className="w-full">
    {withTitle && (
      <Skeleton.Input active size="large" style={{ width: 320, height: 32 }} />
    )}
    {Array.from({ length: rows }).map((_, i) => (
      <Skeleton key={i} active paragraph={{ rows: 3 }} />
    ))}
  </Space>
)

export default PageSkeleton
